export enum EducationalLevelEnum {
  Grade10 = 0,
  Grade11 = 1,
  Grade12 = 2,
  Bachelors = 3,
  Masters = 4,
}